import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/WhatsApp.svg.png")